module.exports = __webpack_public_path__ + "static/media/discussions.bbd0a2a9.jpeg";